export default {
  domains: null,
  domain: null,
  emails: null
};
